import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import ClientOnTourFeedback from "components/modal/ClientOnTourFeedback"; // Ensure this is correctly imported
import { notifySuccess } from "utils/toast";
import ClientFeedbackServices from "services/ClientFeedbackServices";

import Tooltip from "@mui/material/Tooltip";
// import FeedbackSmsModal from "components/modal/FeedbackSmsModal";
import { FaInfoCircle } from "react-icons/fa";
import ViewFeedbackModal from "components/modal/ViewFeedbackModal";
import { center } from "@cloudinary/url-gen/qualifiers/textAlignment";
import ClientEscalationModal from "components/modal/ClientEscalationModal";
import { FiFile } from "react-icons/fi";
import ItineraryModal from "components/form/ItineraryModal";

const getEscalationStatus = (escalationArray) => {
  if (!Array.isArray(escalationArray) || escalationArray.length === 0) {
    return null; // no escalation → no icon
  }

  const latest = escalationArray[escalationArray.length - 1];
  return latest?.status; // "ongoing" or "sorted"
};

const getSortedCount = (escalationArray) => {
  if (!Array.isArray(escalationArray) || escalationArray.length === 0) return 0;
  return escalationArray.filter((item) => item.status === "sorted").length;
};

const OnTourFeedbackTable = ({
  clientfeedback,
  perpage,
  currentPage,
  fetchFeedback,
  hideView,
  hideEdit,
  hideAdd,
  hideExport,
}) => {
  const { setIsUpdate } = useContext(SidebarContext);

  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showViewFeedbackModal, setShowViewFeedbackModal] = useState(false);
  const [escalateModal, SetEscalateModal] = useState(false);
  const [itinerary, setItinerary] = useState("");
  const [showItineraryModal, setShowItineraryModal] = useState(false);

  // console.log("data from client page", clientfeedback);

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
    setSelectedData(null);
    setError("");
  };

  const handleSubmit = async (updatedData) => {
    const payload = {
      client_id: updatedData.client_id,
      feedback: updatedData.ontour_feedback,
    };
    // console.log("payload data of ontour", payload);

    try {
      const response = await ClientFeedbackServices.clientfeedbackOnTourList(
        updatedData.client_id,
        payload
      );
      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        setError("Failed to update the feedback.");
      }
      // console.log("...", response);
    } catch (error) {
      console.error("API Error:", error);
      setError("An error occurred while updating feedback.");
    }
  };
  
  return (
    <>
      <ClientOnTourFeedback
        isOpen={showModal}
        onClose={closeModal}
        handleSubmit={handleSubmit}
        data={selectedData}
        error={error}
        hideAdd={hideAdd}
        hideEdit={hideEdit}
        hideView={hideView}
      />

      <ViewFeedbackModal
        isOpen={showViewFeedbackModal}
        onClose={() => setShowViewFeedbackModal(false)}
        data={selectedData}
      />

      <ClientEscalationModal
        isOpen={escalateModal}
        onClose={() => {
          SetEscalateModal(false);
          fetchFeedback();
        }}
        data={selectedData}
        error={error}
        hideAdd={hideAdd}
        hideEdit={hideEdit}
        hideView={hideView}
        hideExport={hideExport}
      />

      <TableBody>
        {clientfeedback
          .slice((currentPage - 1) * perpage, currentPage * perpage)
          .map((data, index) => {
            const isFeedbackFilled =
              data?.query_driver ||
              data?.query_vehicle ||
              data?.query_depart ||
              data?.query_itinerary ||
              data?.driver_rating ||
              data?.vehicle_rating ||
              (data?.additional_comment &&
                data?.additional_comment.trim() !== "");
            return (
              <TableRow key={data.id}>
                <TableCell className="text-xs text-center">
                  {(currentPage - 1) * perpage + index + 1}
                </TableCell>
                <TableCell className="text-xs text-center">
                  {data.ref_no}
                  <div className="text-center pt-2 text-blue-400">
                    <span>{data.agent_ref_no}</span>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex flex-col items-center">
                    <span className="text-sm">{data.start_date}</span>
                    <span className="text-sm">{data.end_date}</span>
                  </div>
                </TableCell>

                <TableCell className="items-left">
                  <div className="text-sm text-left flex flex-col gap-4">
                    {/* Arrival Section */}
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-green-500">A:</span>
                      <span>{data.arrival || "N/A"}</span>
                    </div>
                    {/* {console.log(data)} */}
                    {/* Departure Section */}
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-red-500">D:</span>
                      <span>{data.departure || "N/A"}</span>
                    </div>
                  </div>
                </TableCell>

                <TableCell>
                  <div className="text-sm flex flex-col items-center space-y-3">
                    <Tooltip title={data.client_number || "No mobile"} arrow>
                      {data.client_name}
                    </Tooltip>
                    <span className="text-center pt-2 text-blue-400">
                      {data.company_name}
                    </span>
                  </div>
                </TableCell>

                <TableCell className="text-center">
                  <span className="text-sm">{data.days_to_complete}</span>
                </TableCell>
                <TableCell className="text-center">
                  <span
                    className="text-sm text-green-600 cursor-pointer inline-block"
                    onClick={() => {
                      setSelectedData(data);
                      setShowModal(true);
                    }}
                  >
                    Action
                  </span>{" "}
                  /<span> </span>
                  <span
                    className="text-sm text-red-600 cursor-pointer inline-flex items-center gap-1"
                    onClick={() => {
                      setSelectedData(data);
                      SetEscalateModal(true);
                    }}
                  >
                    <span>Escalation</span>

                    {getEscalationStatus(data?.ontour_escalation) ===
                      "ongoing" && (
                      <Tooltip
                        title={
                          <div className="text-xs text-center">
                            <strong>Status:</strong> Ongoing
                          </div>
                        }
                        placement="top"
                        componentsProps={{
                          tooltip: {
                            sx: { fontSize: "12px", padding: "8px" },
                          },
                        }}
                      >
                        <span className="text-blue-500 cursor-pointer">
                          <FaInfoCircle />
                        </span>
                      </Tooltip>
                    )}
                    {getEscalationStatus(data?.ontour_escalation) ===
                      "sorted" && (
                      <span className="bg-gray-300 text-gray-700 rounded-full w-4 h-4 flex items-center justify-center text-xs font-semibold">
                        {getSortedCount(data?.ontour_escalation)}
                      </span>
                    )}
                  </span>
                </TableCell>

                <TableCell className="text-sm text-center">
                  <div className="text-sm flex flex-col items-center space-y-3">
                    <span>{data.package_type}</span>
                    <Tooltip title={data.seller_mobile || "No mobile"} arrow>
                      <span className="text-center pt-2 text-blue-400">
                        {data.seller}
                      </span>
                    </Tooltip>
                  </div>
                </TableCell>

                <TableCell className="text-sm text-center">
                  <div className="text-sm flex flex-col items-center space-y-3">
                    {data.itinerary && (
                    <span
                                            onClick={() => {
                                              setShowItineraryModal(true);
                                              setItinerary(data.itinerary);
                                            }}
                                            title="Itinerary"
                                            className="cursor-pointer text-xl text-green-500"
                                          >
                                            <FiFile />
                                          </span>
                    )}
                    <Tooltip
                      title={
                        data.special_note ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: data.special_note,
                            }}
                          />
                        ) : null
                      }
                    >
                      <span
                        className="text-sm flex justify-center"
                        style={{
                          cursor: data.special_note ? "pointer" : "default",
                        }}
                      >
                        {data.special_note ? "Special Note" : "-"}
                      </span>
                    </Tooltip>

                    {data.vehicle_note && data.vehicle_note.trim() !== "" && (
                      <Tooltip
                        title={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: data.vehicle_note,
                            }}
                          />
                        }
                      >
                        <div
                          className="text-sm flex justify-center mt-1 text-gray-600"
                          style={{ cursor: "pointer" }}
                        >
                          Vehicle note
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </TableCell>

                <TableCell className="text-sm text-center">
                  <Tooltip
                    title={data.transport_manager_number || "No mobile"}
                    arrow
                  >
                    {data.transport_manager_name}
                  </Tooltip>
                </TableCell>

                <TableCell className="text-sm text-center">
                  <Tooltip title={data.vehicle_remark}>
                    <span>{data.vehicle_remark ? `Remark` : "-"}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
      <ItineraryModal
              isOpen={showItineraryModal}
              content={itinerary}
              onClose={() => setShowItineraryModal(false)}
            />
    </>
  );
};

export default OnTourFeedbackTable;
